import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTimepickerModule } from '@cmps/ng-bootstrap';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsNoteModule } from '../../../../coaching-note/notes.module';
import { CmpsCoachingTagsModule } from '../../../../coaching-tags/coaching-tags.module';
import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsDateRangeModule } from '../../../../common/component/date-range';
import { CmpsDateTimePickerModule } from '../../../../common/component/datetime-picker';
import { CmpsCommentModule } from '../../../../evaluation/comment';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';
import { epicObs } from '../../../../store';

import { TeamschatTranscriptsDialogBoxComponent } from './teamschat-transcript-dialog.component';
import { teamschatTranscriptDialogEpics } from './teamschat-transcript-dialog.epic';
import { TranslationIdMap } from './teamschat-transcript-dialog.i18n';

@NgModule({
    declarations: [TeamschatTranscriptsDialogBoxComponent],
    exports: [TeamschatTranscriptsDialogBoxComponent],
    imports: [
        CmpsButtonModule,
        CmpsCheckboxModule,
        CmpsCoachingTagsModule,
        CmpsCommonModule,
        CmpsCommentModule,
        CmpsDateRangeModule,
        CmpsDateTimePickerModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsNoteModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
    ],
})
export class CmpsCoachingTeamschatTranscriptDialogModule {
    constructor() {
        teamschatTranscriptDialogEpics.forEach((e) => epicObs.next(e));
    }
}
